'use client';

export { InventoryScreen } from './InventoryScreen';
